import { useNavigate } from "react-router-dom";
import Image from "../../assets/images/error-403.svg"

const Error403Page = () => {

    const navigate = useNavigate();

    return (
        <div id="layoutError">
            <div id="layoutError_content">
                <main>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="text-center my-5 mt-sm-10">
                                    <img className="img-fluid mb-4" src={Image} alt="403 Error Image by Freepik Storyset" style={{ maxWidth: '30rem' }} />
                                        <p className="lead">Acesso negado. Você não tem permissão para acessar esta página.</p>
                                        <button className="btn btn-primary mdc-ripple-upgraded" type="button" onClick={() => navigate(-1)}>
                                            <i className="material-icons leading-icon">arrow_back</i>
                                            Voltar para página anterior
                                        </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>            
        </div>
    )

}

export default Error403Page;
